import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import "./Upgrade.scss";

const UpgradeButton = ({ className }) => {
    const history = useHistory();
    const freeTrialDaysLeft = useSelector((state) => state.globalReducer.freeTrialDaysLeft);

    // console.log(freeTrialDaysLeft);
    const textContent =
        freeTrialDaysLeft === 0
            ? "Your free trial pack is expiring today!"
            : freeTrialDaysLeft < 0
            ? `Your Free trial expired!`
            : `${freeTrialDaysLeft} days left in your free trial!`;

    return (
        <div className="upgrade__container">
            {/* <div className="upgrade__text">
                {freeTrialDaysLeft === 0 ? "Your free trial pack is expiring today!" : `${freeTrialDaysLeft} days left in your free trial!`}
            </div> */}
            <Popup
                content={textContent}
                inverted
                size="mini"
                className="upgrade__to__premium"
                trigger={
                    <div
                        className={`upgrade__button ${className && className}`}
                        onClick={() => {
                            history.push("/subscription");
                        }}>
                        <span> Upgrade Now</span>
                    </div>
                }
                position="bottom center"
            />
        </div>
    );
};

export default UpgradeButton;
